export default __webpack_public_path__ + "static/media/65.f842728f.jpg";